import styled from '@emotion/styled'

export const GridContent = styled.div({
	display: 'grid',
	gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
	gap: 24,
	marginTop: 40,
	'@media (min-width: 800px)': {
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
	}
})